export default __webpack_public_path__ + "static/ClientProfiles-bg-dc4d0e5ae4c84e9d67838df08551084a.png";